import {
  ApiFilterOperation,
  Filter,
  useScrollableSource,
} from '@eas/common-web';
import { useWorkOrdersAbortableList } from '@modules/work-order/work-order-api';
import { WorkOrder } from '@models';
import { EvidenceApiUrl } from '@enums';

type WorkOrderSourceParams = {
  filters?: Filter[];
  [key: string]: unknown;
};

const currentStateFilter: Filter = {
  field: 'currentState',
  operation: ApiFilterOperation.NOT_NULL,
};

const isCurrentStateFilter = (filter: Filter) =>
  filter.field === currentStateFilter.field &&
  filter.operation === currentStateFilter.operation;

const removeRuntimeCalendarFilter = (filters: Filter[] = []) =>
  filters.filter((filter) => filter.field !== 'id');

const ensureCurrentStateFilter = (filters: Filter[]) => {
  if (filters.some(isCurrentStateFilter)) {
    return filters;
  }

  return [currentStateFilter, ...filters];
};

export function createWorkOrderSourceFilters(): Filter[] {
  return [currentStateFilter];
}

export function mergeCalendarWorkOrderFilter(
  params: WorkOrderSourceParams = {},
  ids?: string[]
): WorkOrderSourceParams {
  const filters = ensureCurrentStateFilter(
    removeRuntimeCalendarFilter(params.filters)
  );

  if (ids?.length) {
    filters.push({
      field: 'id',
      operation: ApiFilterOperation.IN,
      values: ids,
    });
  }

  return {
    ...params,
    filters,
  };
}

export function clearCalendarWorkOrderFilter(
  params: WorkOrderSourceParams = {}
): WorkOrderSourceParams {
  const filters = ensureCurrentStateFilter(
    removeRuntimeCalendarFilter(params.filters)
  );

  return {
    ...params,
    filters,
  };
}

export function useWorkOrderDataSource() {
  return useScrollableSource<WorkOrder>({
    url: `${EvidenceApiUrl.WORK_ORDERS}/list`,
    params: {
      filters: createWorkOrderSourceFilters(),
    },
    listItems: useWorkOrdersAbortableList,
  });
}
